function i() {
  return "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white focus-visible:ring-2 focus-visible:ring-blue-600";
}
function e() {
  return "focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-white focus-within:ring-2 focus-within:ring-blue-600";
}
export {
  i as getAccessibleFocusStyles,
  e as getFocusWithinAccessibleStyles
};
